import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {LayerEntity} from './layer.entity';
import {LayoutEntity} from './layout.entity';

@EntityTable('layout_layer_xref', 'eb9720df-6c1b-40ac-806b-4a8adb0301e9')
export class LayoutLayerXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, LayoutEntity, false, false, FieldRelationKind.BELONGS_TO, 'layout', 'aliasId', 'layoutId')
    public layoutId: string;

    @JoinColumn(FieldTypeKind.GUID, LayerEntity, false, false, FieldRelationKind.BELONGS_TO, 'layer', 'aliasId', 'layerId')
    public layerId: string;

    @Column(FieldTypeKind.LONG)
    public index: number;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Transient()
    public layer: LayerEntity;

}
